export default "__VITE_ASSET__BppAk2eX__"